<template>
  <div class="b-modal-custom">
    <b-modal
      id="example-modal"
      ref="modal"
      class="w-100"
      :modal-class="isMobile ? 'bottom-modal b-modal-custom' : 'b-modal-custom'"
      v-model="showModal"
      no-close-on-backdrop
      hide-header-close
      centered
    >
      <template #modal-title>
        <article
          class="
            d-flex
            justify-content-between
            gap-2
            align-items-center
            w-100
            report-modal-hd
          "
        >
          <h2 class="report-txt mb-0 ml-2">Reasons for report</h2>
          <div class="pointer" @click="hideModal">
            <img
              src="@/assets/New-imgs/teams-icons/teams-close-icon.svg"
              alt=""
              class="rotatable-icon"
            />
          </div>
        </article>
      </template>

      <template>
        <article class="report-md-body">
          <SelectCustom
            :values="reportOptions"
            :label="'Reason'"
            :vmodel="reportType"
            :placeholder="'Select reason'"
            :dropdown="true"
            :mandatory="true"
            @select-value="handleSelectedCategory"
            :showError="$v.reportType.$error"
          />
          <span
            v-show="$v.reportType.$error"
            class="required-font tu-l0 left-30px errortxt"
            >Required</span
          >
          <b-form class="mt-3">
            <b-form-group>
              <div class="remarks-txt">
                Remarks<span class="text-danger">*</span>
              </div>
              <b-form-textarea
                id="remarks"
                v-model.trim="$v.remarks.$model"
                placeholder="Enter"
                rows="3"
                max-rows="5"
                :class="{ error: $v.remarks.$error }"
              ></b-form-textarea>
              <span
                v-show="!$v.remarks.required && $v.remarks.$dirty"
                class="required-font tu-l0 left-30px errortxt"
                >Required</span
              >
              <span
                v-show="$v.remarks.required && !$v.remarks.maxLength"
                class="required-font tu-l0 left-30px errortxt"
                >Should not exceed 1000 characters</span
              >
            </b-form-group>
          </b-form>
        </article>
      </template>
      <template #modal-footer>
        <div class="d-flex justify-content-end gap-2 w-50 position-relative">
          <b-button class="acs-cancelBtn-modal mr-3 w-100" @click="hideModal"
            >Cancel</b-button
          >
          <b-button @click="sendReport" class="acs-addBtn-modal w-100">{{
            loading ? "" : "Report"
          }}</b-button>
          <div v-if="loading" class="report-loader-pos">
            <Loader />
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Loader from "../../components/fixedcomponents/Loader.vue";
import { raiseReport } from "../../utils/apiFunctions";
import { required, maxLength } from "vuelidate/lib/validators";
import toast from "../../components/mixin/toast";
import SelectCustom from "../../components/InputComponents/SelectCustom.vue";
export default {
  name: "ReportModal",
  mixins: [toast],
  components: { SelectCustom, Loader },
  props: {
    showModal: Boolean,
    isMobile: Boolean,
    referenceID: String,
    referenceType: String,
  },
  watch: {
    showModal(val) {
      if (val) {
        console.log("showModal", val);
      }
    },
  },
  data() {
    return {
      platformOptions: [
        {
          key: "Didn’t receive timely support",
          label: "Didn’t receive timely support",
        },
        {
          key: "Difficult to contact support",
          label: "Difficult to contact support",
        },
        { key: "Issue unresolved", label: "Issue unresolved" },
        {
          key: "Faced a technical error or bug",
          label: "Faced a technical error or bug",
        },
        { key: "Login or access issue", label: "Login or access issue" },
        {
          key: "Page not loading properly",
          label: "Page not loading properly",
        },
        {
          key: "Notification/email not received",
          label: "Notification/email not received",
        },
        { key: "Poor content quality", label: "Poor content quality" },
        {
          key: "Platform is slow or unresponsive",
          label: "Platform is slow or unresponsive",
        },
        { key: "Others", label: "Others" },
      ],

      reportType: "",
      remarks: "",
      loading: false,
    };
  },
  computed: {
    reportOptions() {
      return this.referenceType === "11" ? this.platformOptions : "";
    },
  },
  validations() {
    return {
      remarks: {
        required,
        maxLength: maxLength(1000),
      },
      reportType: {
        required,
      },
    };
  },
  methods: {
    handleSelectedCategory(selectedOption) {
      this.reportType = selectedOption;
    },
    async sendReport() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          this.loading = true;
          let payload = {
            title: this.reportType,
            remarks: this.remarks,
            referenceID: this.referenceID,
            createdByType: "4",
            module: "5",
            category: this.referenceType,
          };

          const response = await raiseReport(payload);

          if (response.status === 200) {
            this.$emit("report-success");
            this.hideModal();
            this.$nextTick(() => {
              this.successModal(response.data.data.Detail);
            });
          } else {
            this.errorModal(response.data.data.Detail);
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    hideModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style>
.b-modal-custom .modal-content {
  border: unset !important;
}
.b-modal-custom .modal-header {
  padding: 0 !important;
}

#example-modal .modal-body {
  padding: 0 10px 0 10px !important;
}
.b-modal-custom .report-txt {
  font-family: Lato;
  font-weight: 500 !important;
  font-size: 18px !important;
  color: #000000 !important;
}

.b-modal-custom .modal-title {
  width: 100%;
}

.b-modal-custom .report-modal-hd,
.report-md-body {
  padding: 15px 24px 15px 10px;
}

.b-modal-custom .remarks-txt {
  font-family: "Montserrat", sans-serif !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #344054 !important;
}

.b-modal-custom .text-danger {
  color: red !important;
}

.b-modal-custom .form-control:focus {
  background: unset !important;
  /* border-color: #d0d5dd !important; */
}

.b-modal-custom .form-control {
  font-size: 14px !important;
  font-family: "Montserrat", sans-serif !important;
  font-weight: 500 !important;
}

.b-modal-custom .form-control::placeholder {
  font-size: 14px !important;
  font-family: "Montserrat", sans-serif !important;
  font-weight: 400 !important;
  color: #667085 !important;
}

.b-modal-custom textarea {
  resize: none;
}

.b-modal-custom textarea.form-control {
  border-radius: 8px !important;
}

.b-modal-custom .report-btn:hover {
  color: #ffffff !important;
}
.report-md-body .single-select {
  margin: 0;
}
.left-30px {
  left: 30px;
}
#example-modal .selectCustom-dropdown {
  width: 90%;
}
.report-loader-pos {
  position: relative;
  height: 10px;
  z-index: 14;
  left: -105px;
  top: -31px;
}
</style>
